<template>
  <div class="product-box">
    <div class="tit-fixed">
      <div class="jarallax-container">
        <div class="cst_container_base">
          <el-skeleton :loading="newsloading" animated>
            <template slot="template">
              <el-skeleton-item variant="h1" style="width: 10%;" />
              <h2></h2>
              <el-skeleton-item variant="h3" style="width: 40%;" />
            </template>
            <template>
              <h1>{{ newsForm.newsClassName }}</h1>
              <h2></h2>
              <h3>{{ newsForm.newsTitle }}</h3>
            </template>
          </el-skeleton>
        </div>
      </div>
    </div>
    
    <div class="list-wrap">
      <div class="zhanwei"></div>
      <div class="wrap">
        <div class="cbsect_5700dd5c">
          <div class="cbdiv_ad72d4a4">
            <div class="content_box">
              <div class="text_box">
                <el-skeleton :loading="newsloading" animated>
                  <template slot="template">
                    <el-skeleton-item variant="h2" style="width: 40%;" />
                    <el-skeleton :rows="6" animated />
                    <el-skeleton :rows="6" animated />
                  </template>
                  <template>
                    <h2>{{ newsForm.newsTitle }}</h2>
                    <span>{{ newsForm.updateDatetime }}</span>
                    <p class="line">{{ newsForm.description }}</p>
                    <p v-html=" newsForm.content "></p>
                  </template>
                </el-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>

import News from '@/api/api.js'

export default {
  data() {
    return {
      newsForm: {},
      newsloading: true
    }
  },
  created() {
    const id = this.$route.params.id;
    this.getNews(id)
    
    this.$watch('newsForm.content', this.addImgClass)
  },
  methods: {
    async getNews(id) {
      let res = await News.getNew(id);
      if (res.code === 0){
        if (res.msg.newsClassId == 1) {
          res.msg.newsClassName = '公司动态'
        } else if (res.msg.newsClassId == 2) {
          res.msg.newsClassName = '行业新闻'
        } else if (res.msg.newsClassId == 3) {
          res.msg.newsClassName = '典型案例'
        } else if (res.msg.newsClassId == 4) {
          res.msg.newsClassName = '科技项目'
        } else {
          res.msg.newsClassName = '北京理工华创'
        }
        this.newsForm = res.msg;
        this.newsloading = false
      } else{
        this.$message.error(res.msg);
      }
    }
  }
};
</script>
  
  <style lang="scss"  scoped >
  .tit-fixed .cst_container_base h3 {
    font-size: 20px;
  }
.product-box {
  position: relative;

  background: linear-gradient(rgba(28, 69, 135, 0.7), rgb(32, 18, 77)),
    url("../../assets/image/news_bg.jpg") center center / cover no-repeat;
  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    // -webkit-box-shadow: inset 0 0 5px #99aeff;
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    background: #99aeff;
  }
  &::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 5px #99aeff;
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
.cbsect_5700dd5c {
  padding: 0px;
  // background-color: rgb(7, 55, 99);
  min-height: 20px;
  .cbdiv_ad72d4a4 {
    margin: 0 auto;
    width: var(--base-width);
    color: #fff;
   
    .content_box {
      width: 100%;
      background: #fff;
      color: #000;
      padding: 50px 0;
      top: -100px;
      position: relative;
      box-shadow: 0 0 6px rgba(0,0,0, .12);
      .text_box {
        width: var(--base-width);
        margin: 0 auto;
        h2 {
          line-height: 1.5em;
          margin-top: 0px;
          border-bottom: 1px none rgb(179, 179, 179);
          border-top-style: none;
          border-right-style: none;
          border-left-style: none;
          margin-bottom: 15px;
          font-size: 30px;
          font-weight: normal;
        }
        span {
          font-size: 14px;
          margin-bottom: 30px;
        }
        p {
          font-size: 14px;
          text-align: justify;
          line-height: 30px;
        }
        p.line {
          margin: 10px 0;
          padding: 10px 0;
          border: 1px dashed #a6a6a6;
          border-left: 0;
          border-right: 0;
        }
      }
       .top_img {
        width: var(--base-width);
        margin: 0 auto;
      img {
        width: 100%;
      }
    }
    }
    h3 {
      line-height: 1.3em;
      margin-top: 0px;
      font-family: Roboto;
      padding-left: 2px;
      padding-right: 2px;
      font-weight: lighter;
      font-size: 36px;
      font-weight: 200;
    }
  }
}


.animate {
  opacity: 0;
}
.fadeInUpBig {
  animation: fadeInUpBig 1s;
}
.rollIn {
  animation: rollIn 1s;
}
.slideInRight {
  animation: slideInRight 1s;
}
.bounceInLeft {
  animation: bounceInLeft 2s ease-in;
}
.bounceInRight {
  animation: bounceInRight 2s ease-in;
}
</style>


// WEBPACK FOOTER //
// src/view/webapp/NewDetail.vue